(() => {
  if (!location.pathname.startsWith('/collections/')) return;

  const gridSelector = '#product-grid, [id^="product-grid"]';
  const nextSelector = '.pagination a[aria-label="Next page"], .pagination a[rel="next"]'; 

  let loading = false;
  let finished = false;

  async function loadMore() {

    if (loading || finished) return;
    const grid = document.querySelector(gridSelector);
    const pagination = document.querySelector('.pagination');
    const next = pagination?.querySelector(nextSelector);

    if (!grid || !next?.href) {
      finished = true;
      return;
    }

    loading = true;

    try {
      const response = await fetch(next.href);
      if (!response.ok) throw new Error('Page load failed');

      const doc = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      );

      const newGrid = doc.querySelector(gridSelector);
      const newPagination = doc.querySelector('.pagination');

      if (!newGrid) throw new Error('Product grid not found');

      [...newGrid.children].forEach(item => {
        grid.appendChild(document.importNode(item, true));
      });

      if (newPagination) {
        pagination.replaceWith(
          document.importNode(newPagination, true)
        );
      } else {
        pagination.remove();
        finished = true;
      }

      attachObserver();
    } catch (error) {
      console.error('Infinite scroll:', error);
      finished = true;
    } finally {
      loading = false;
    }
  }

  let observer;

  function attachObserver() {
    observer?.disconnect();

    const pagination = document.querySelector('.pagination');
    if (!pagination || finished) return;

    pagination.style.visibility = 'hidden';

    observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) loadMore();
    }, { rootMargin: '500px' });

    observer.observe(pagination);
  }

  attachObserver();
})();
